"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TableRow = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _TrialPlanSubRow = _interopRequireDefault(require("./TrialPlanSubRow"));

var _right_arrow = _interopRequireDefault(require("../../../asset/icons/right_arrow.svg"));

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var areEqual = function areEqual(prevProps, nextProps) {
  if (prevProps.isActive !== nextProps.isActive) {
    return false;
  }

  if (prevProps.rowContent.count_trial_sets !== nextProps.rowContent.count_trial_sets || !_lodash["default"].isEqual(prevProps.rowContent.coop_trial_list, nextProps.rowContent.coop_trial_list)) {
    return false;
  }

  return true;
};

var trialPlanHeaders = [['Name', 'reseller_name'], ['Trial Set Name', ''], ['RM Range', ''], ['City', 'reseller_city'], ['State', 'reseller_state'], ['# of Trials', 'count_trial_sets']];

var TableRow = function TableRow(props) {
  var myMap = new Map(trialPlanHeaders);

  var fillRow = function fillRow(rowContent) {
    var filler = [];
    myMap.forEach(function (value, key) {
      filler.push( /*#__PURE__*/_react["default"].createElement("div", {
        key: key,
        className: "cell"
      }, value && rowContent[value] ? rowContent[value] : '-'));
    });
    return filler;
  };

  var clickHandler = function clickHandler() {
    props.handleClick(props.id);
  };

  var renderRow = function renderRow() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "tableRow ".concat(props.isActive ? 'selected' : ''),
      onClick: clickHandler
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "primary"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: _right_arrow["default"],
      className: "rowButton ".concat(props.isActive ? 'down' : ''),
      alt: "row arrow"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "rowContent"
    }, true && fillRow(props.rowContent))), props.isActive && /*#__PURE__*/_react["default"].createElement("div", {
      className: "subMenu"
    }, renderSubMenu(props.rowContent.coop_trial_list)));
  };

  renderRow.propTypes = {
    rowContent: _propTypes.object,
    isActive: _propTypes.bool
  };

  var renderSubMenu = function renderSubMenu(children) {
    return children.map(function (child, index) {
      if (props.rowContent && props.rowContent.reseller_id) {
        child.reseller_id = props.rowContent.reseller_id;
      }

      return /*#__PURE__*/_react["default"].createElement(_TrialPlanSubRow["default"], {
        key: child.coop_id || index,
        index: index,
        rowContent: child
      });
    });
  };

  return renderRow();
};

exports.TableRow = TableRow;

var _default = /*#__PURE__*/_react["default"].memo(TableRow, areEqual);

exports["default"] = _default;
TableRow.propTypes = {
  id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  rowContent: _propTypes.object.isRequired,
  handleClick: _propTypes.func,
  structure: _propTypes.object,
  isActive: _propTypes.bool,
  cooperator: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    can_delete: _propTypes.string,
    coop_address: _propTypes.string,
    coop_city: _propTypes.string,
    coop_email: _propTypes.string,
    coop_id: _propTypes.number,
    coop_name: _propTypes.string,
    coop_state: _propTypes.string
  }).isRequired)
};